import Vue from 'vue'
import axios from 'axios'
import notification from 'ant-design-vue/es/notification'
import { VueAxios } from './axios'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import errorCode from '@/const/errorCode'

axios.defaults.timeout = 600000;
// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL, // api base_url
  headers: { "Content-Type": "application/json;charset=utf-8" }, //即将被发送的自定义请求头
  withCredentials: true, //表示跨域请求时是否需要使用凭证
  timeout: 600000 // 请求超时时间
})
// 跨域请求，允许保存cookie
axios.defaults.withCredentials = true

const err = (error) => {
  if (error.response) {
    const data = error.response.data
    //状态码
    const status = error.response.status
    const message = errorCode[status] || data.msg || errorCode['default']
    const token = Vue.ls.get(ACCESS_TOKEN)
    // if (status === 401) {
    //   notification.error({
    //     message: '系统提示',
    //     description: data.msg
    //   })
    // } else {
    //   notification.error({
    //     message: '系统提示',
    //     description: message,
    //     duration: 4
    //   })
    // }    
    if (status === 401) {
      if (data.msg){
        notification.error({
          message: '系统提示',
          description: data.msg
        })
      }
      // location.reload();
    } else {
      if (message){
        notification.error({
          message: '系统提示',
          description: message,
          duration: 4
        })
      }
    }
  }
  return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use(config => {
  const token = Vue.ls.get(ACCESS_TOKEN)
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  return config
}, err)

// response 拦截器
service.interceptors.response.use((response) => {
  return response.data

}, err)

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, service)
  }
}

export {
  installer as VueAxios,
  service as axios
}
